import React from 'react'
import { Descriptions } from 'antd'
import { CompanyData } from '../../../../services/api/companies'
import { FeatureEnabled } from '../../../../components'

const { Item } = Descriptions
type Props = {
  company: CompanyData
}

export const Settings: React.FunctionComponent<Props> = ({ company }) => {
  return (
    <Descriptions bordered column={1}>
      <Item label="Создание заказов включено">
        <FeatureEnabled value={company.ordersEnabled} />
      </Item>
    </Descriptions>
  )
}
